import logo from "@/assets/logo-sr.png";
import { ShoppingCart, Menu, X, Instagram } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/contexts/CartContext";
import SupportDialog from "@/components/SupportDialog";
import UserDropdown from "@/components/UserDropdown";
import NotificationCenter from "@/components/NotificationCenter";
const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { totalItems, setIsOpen } = useCart();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-b border-gold animate-[fade-in_0.5s_ease-out]">
      <div className="container mx-auto flex items-center justify-between py-3 px-4">
        <a href="/" className="flex items-center hover:scale-105 transition-transform">
          <span className="inline-flex" style={{ width: 40, height: 40, padding: 0, overflow: "hidden", borderRadius: "50%" }}>
            <img src={logo} alt="SR Software" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%", display: "block" }} />
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          <a href="/#celulares" className="text-sm font-medium text-foreground hover:text-primary transition-colors story-link">Celulares</a>
          <a href="/seminovos" className="text-sm font-medium text-foreground hover:text-primary transition-colors story-link">Seminovos</a>
          <a href="/seguro" className="text-sm font-medium text-foreground hover:text-primary transition-colors story-link">Seguro</a>
          <a href="/pagamento" className="text-sm font-medium text-foreground hover:text-primary transition-colors story-link">Pagamento</a>
          <a href="/contato" className="text-sm font-medium text-foreground hover:text-primary transition-colors story-link">Contato</a>
        </div>

        <div className="flex items-center gap-3">
          <a href="https://www.instagram.com/srsoftware.ofc?igsh=NGRkeXJ1dzdwNnJq&utm_source=qr" target="_blank" rel="noopener noreferrer" className="p-2 text-foreground hover:text-pink-500 hover:scale-110 transition-all" aria-label="Instagram">
            <Instagram className="w-5 h-5" />
          </a>
          <SupportDialog />
          <NotificationCenter />
          <UserDropdown />
          <a href="/carrinho" className="relative p-2 text-foreground hover:text-primary hover:scale-110 transition-all" aria-label="Carrinho de compras">
            <ShoppingCart className="w-5 h-5" />
            {totalItems > 0 && (
              <span className="absolute -top-1 -right-1 bg-gradient-gold text-primary-foreground text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold animate-[scale-in_0.3s_ease-out]">
                {totalItems}
              </span>
            )}
          </a>
          <button className="md:hidden text-foreground" onClick={() => setOpen(!open)}>
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background/95 backdrop-blur-xl border-b border-gold px-4 pb-4 space-y-3 animate-[fade-in_0.2s_ease-out]">
          <a href="/#celulares" className="block text-sm py-2 text-foreground hover:text-primary" onClick={() => setOpen(false)}>Celulares</a>
          <a href="/seminovos" className="block text-sm py-2 text-foreground hover:text-primary" onClick={() => setOpen(false)}>Seminovos</a>
          <a href="/seguro" className="block text-sm py-2 text-foreground hover:text-primary" onClick={() => setOpen(false)}>Seguro</a>
          <a href="/pagamento" className="block text-sm py-2 text-foreground hover:text-primary" onClick={() => setOpen(false)}>Pagamento</a>
          <a href="/contato" className="block text-sm py-2 text-foreground hover:text-primary" onClick={() => setOpen(false)}>Contato</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
